import React from "/vendor/react";

import NameSearchBox from "/lib/component/partial/NameSearchBox";

const ChecksSearchBox = () => (
  <NameSearchBox
    aria-label="Search checks"
    placeholder={"Search checks by name\u2026"}
  />
);

export default ChecksSearchBox;
